import { TOP_RISING, TOP_RISING_RIGHT } from '@/mocks/data';

type RankItem = { rank: number; title: string; delta: string; heat: number; width: number };

const numberColor = (rank: number) => {
  if (rank === 1) return 'text-primary-600';
  if (rank === 2) return 'text-accent-600';
  if (rank === 3) return 'text-accent-500';
  if (rank <= 5) return 'text-foreground-500';
  return 'text-foreground-400';
};

const deltaStyle = (d: string) => {
  if (d === '爆') return 'bg-primary-100 text-primary-700';
  if (d === '新') return 'bg-secondary-100 text-secondary-700';
  return 'bg-accent-100 text-accent-800';
};

const barColor = (rank: number) => {
  if (rank === 1) return 'bg-primary-500';
  if (rank === 2) return 'bg-accent-500';
  if (rank === 3) return 'bg-accent-400';
  if (rank <= 5) return 'bg-secondary-400';
  return 'bg-foreground-300';
};

function RankRow({ item, big }: { item: RankItem; big?: boolean }) {
  return (
    <div className="group flex cursor-pointer items-center gap-3 rounded-xl px-2 py-2.5 transition-colors hover:bg-background-50 md:px-3">
      <span className={`w-7 shrink-0 text-center font-heading text-xl font-black tabular-nums ${numberColor(item.rank)} md:text-2xl`}>
        {item.rank}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className={`min-w-0 flex-1 text-sm leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base ${big ? 'font-bold' : 'font-medium'}`}>
            {item.title}
          </h3>
          <span className={`shrink-0 rounded px-1.5 py-px text-[11px] font-semibold ${deltaStyle(item.delta)}`}>{item.delta}</span>
        </div>
        <div className="mt-2 flex items-center gap-2">
          <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
            <span className={`block h-full rounded-full ${barColor(item.rank)}`} style={{ width: `${item.width}%` }}></span>
          </span>
          <span className="shrink-0 text-[11px] tabular-nums text-foreground-500">
            {(item.heat / 10000).toFixed(1)}万
          </span>
        </div>
      </div>
    </div>
  );
}

export default function RankSection() {
  return (
    <section id="rank" className="scroll-mt-24 bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>
              热度风向标
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-[34px]">今日热榜 TOP10</h2>
          </div>
          <p className="max-w-md text-xs leading-relaxed text-foreground-500 md:text-sm">
            综合社交讨论、搜索与话题参与热度多源计算，仅供参考的公众关注风向。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          <div className="rounded-2xl border border-background-200 bg-background-100 p-3 md:p-4">
            {TOP_RISING.map((it) => (
              <RankRow key={it.rank} item={it} big />
            ))}
          </div>
          <div className="rounded-2xl border border-background-200 bg-background-100 p-3 md:p-4">
            {TOP_RISING_RIGHT.map((it) => (
              <RankRow key={it.rank} item={it} />
            ))}
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 rounded-2xl border border-primary-100 bg-primary-50 px-5 py-4">
          <span className="flex items-center gap-2 text-sm font-bold text-primary-900">
            <i className="ri-information-line text-lg"></i>
            榜单小提示
          </span>
          <p className="min-w-0 flex-1 text-xs leading-relaxed text-primary-800 md:text-sm">
            热度条为相对热度展示,仅反映一段时间的公众关注趋势。榜单每 15 分钟自动归并刷新,点击任意话题可查看更完整的来龙去脉。
          </p>
        </div>
      </div>
    </section>
  );
}